@for (chip of chips(); track chip.id) {
  <button
    type="button"
    mibButton
    theme="secondary"
    shape="round"
    class="shrink-0"
    [class]="chipClasses()"
    [size]="size()"
    [active]="isPressed(chip)"
    [attr.aria-pressed]="isPressed(chip)"
    [disabled]="disabled() || !!chip.disabled"
    (click)="press(chip)">
    @if (chip.palette) {
      <span [class]="dotClasses(chip.palette)"></span>
    } @else if (chip.icon) {
      <svg mib-icon [name]="chip.icon" [filled]="isFavouritePressed(chip)" [class]="iconClasses(chip)"></svg>
    }
    {{ chip.label }}
    @if (chip.count !== undefined) {
      <!-- The count keeps the chip's ink: gray-500 falls under 4.5:1 on the grey and pressed fills. -->
      <span aria-hidden="true">·</span>
      <span class="tabular-nums">{{ chip.count }}</span>
    }
  </button>
}
